<template functional>
  <q-card class="fit no-border-radius chart">
    <q-card-section class="header">
      <div class="title">
        <div class="text-body-3">{{ props.title }}</div>
        <slot name="subtitle">
          <div class="text-body-1">Local currency ({{ props.currency }})</div>
        </slot>
      </div>

      <div>
        <slot name="widget-options" />
      </div>
    </q-card-section>

    <q-card-section class="chart-content q-py-sm">
      <div class="col-xs-12">
        <slot name="chart">
          <div class="loader-wrapper">
            <q-spinner color="primary" size="2.5em" />
          </div>
        </slot>
      </div>
    </q-card-section>
    <slot name="bottom-right-desc" />
  </q-card>
</template>

<script>
export default {
  props: {
    title: String,
    currency: String
  }
}
</script>

<style lang="scss" scoped>
.chart {
  display: grid;
  grid-template-rows: auto 1fr;
  background: var(--r-graph-8);
  color: var(--r-white-1);

  .header {
    padding: 25px 20px 0;
    font-size: 16px;
    font-weight: 300;
    display: grid;
    grid-template-columns: 1fr auto;
  }

  .loader-wrapper {
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
